import { array, number, object, string } from 'yup'

export const checkFormFindTour = object().shape({
  duration: number().required(),

  departure: object()
    .shape({
      id: string().required(),
      name: string().required(),
    })
    .required(),

  resorts: array()
    .of(
      object().shape({
        id: string().required(),
      }),
    )
    .min(1)
    .required(),

  flight: object().shape({
    startDay: string().required(),
  }),

  passengers: object().shape({
    adults: number().required(),
    children: number().notRequired(),
    infants: number().notRequired(),
    childrenAges: array().of(number()).notRequired(),
  }),
})
